import React, { useEffect } from 'react';

import styled from 'styled-components';
import { StyledGrid } from 'styles/common';

import { getJobFunctionData } from 'services/growth/admin';

import { useSelectedJobFunctionContext } from '../GrowthSettings';
import { OTHER_ACTIONS, useGrowthTableContext } from './GrowthTableContext';
import { AddDimensionRow } from './GrowthTableHelperComps';
import { DimensionRow } from './components/DimensionRow';
import RoleHeader from './components/RoleHeader';

const GrowthTable = () => {
  const { state: dataObj, tableReducerDispatch: reducerDispatch } = useGrowthTableContext();
  const { selectedJobFunction: jobFunction } = useSelectedJobFunctionContext();

  const fetchData = (jobFunctionId) => {
    getJobFunctionData({ jobFunctionId })
      .then((res) => {
        console.log('INITIAL OBJ', res);
        reducerDispatch({
          type: OTHER_ACTIONS.INITIALIZE,
          payload: res,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (jobFunction) {
      console.log(jobFunction);
      fetchData(jobFunction?.uuid);
    }
    // fetchData();
  }, [jobFunction]);

  return (
    <>
      <StyledGrid
        container
        wrap="nowrap"
        alignItems="stretch"
        justify="stretch"
        style={{ maxHeight: 'calc(100% - 3.5rem)' }}
      >
        <Container>
          <RoleHeader roles={dataObj.roles} isLoading={dataObj.isLoading} layoutReducerDispatch={reducerDispatch} />
          {dataObj.dimensions.map((dimensionObj, index) => {
            const { uuid } = dimensionObj;
            return (
              <DimensionRow
                key={uuid}
                index={index}
                dimensionsCount={dataObj.dimensions.length}
                isLoading={dataObj.isLoading}
                dimensionObj={dimensionObj}
                roles={dataObj.roles}
                rowDataObj={dataObj.data[dimensionObj.uuid]}
                layoutReducerDispatch={reducerDispatch}
              />
            );
          })}
        </Container>
        {/* <AddRoleColumn
          layoutReducerDispatch={reducerDispatch}
          levels={dataObj?.roles}
          isLoading={dataObj?.isLoading}
        /> */}
      </StyledGrid>
      <AddDimensionRow
        layoutReducerDispatch={reducerDispatch}
        dimensions={dataObj?.dimensions}
        isLoading={dataObj?.isLoading}
      />
    </>
  );
};

const Container = styled.div`
  overflow-y: scroll;
  overflow-x: scroll;
  height: 100%;
  max-height: 95vh;
  position: relative;
`;

export default GrowthTable;
